import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  saveCompanyUser: ['companyUser', 'onSuccess', 'onError'],
  removeCompanyUser: ['companyUser', 'onSuccess', 'onError'],
  toggleActivateCompanyUser: ['companyUser', 'onSuccess', 'onError'],
  resetCompanyUserPassword: ['userId', 'onSuccess', 'onError'],
  companyUserError: ['error']
})

const saveCompanyUser = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeCompanyUser = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const toggleActivateCompanyUser = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const resetCompanyUserPassword = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const companyUserError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.COMPANY_USER_ERROR]: companyUserError,

  [Types.SAVE_COMPANY_USER]: saveCompanyUser,
  [Types.REMOVE_COMPANY_USER]: removeCompanyUser,
  [Types.TOGGLE_ACTIVATE_COMPANY_USER]: toggleActivateCompanyUser,
  [Types.RESET_COMPANY_USER_PASSWORD]: resetCompanyUserPassword,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as CompanyUserTypes,
  Creators as CompanyUserActions
}
